import { render, staticRenderFns } from "./bigDataByPro.vue?vue&type=template&id=e3daea3a&scoped=true&"
import script from "./bigDataByPro.vue?vue&type=script&lang=js&"
export * from "./bigDataByPro.vue?vue&type=script&lang=js&"
import style0 from "./bigDataByPro.vue?vue&type=style&index=0&id=e3daea3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3daea3a",
  null
  
)

export default component.exports